export function canManageBuilding({ permissions }){
    return (permissions.manage_building === true)
}

export function canPrepareReserve({ permissions }){
    return (permissions.prepare_reserve === true)
}

export function canActivateReserves({ permissions }){
    return (permissions.activate_reserve === true)
}

export function canReceiveReserveBonus({ permissions }){
    return (permissions.receive_reserve_bonus === true)
}

export function canCreateAnnouncement({ permissions }){
    return (permissions.create_announcement === true)
}

export function isFeatureAvailable({ available_features }, feature){
    return available_features && available_features.includes(feature) || false
}



// WEBPACK FOOTER //
// ./helpers/accounts.js